import { render, staticRenderFns } from "./ViewSettingsUserClients.vue?vue&type=template&id=f06903b8&scoped=true&"
import script from "./ViewSettingsUserClients.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsUserClients.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsUserClients.vue?vue&type=style&index=0&id=f06903b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06903b8",
  null
  
)

export default component.exports